import { Fragment, useCallback, useEffect, useState } from "react";
import MenuCM from "components/shared/menu";
import FooterCM from "components/shared/footer";
import MainSliderCM from "components/mainslider";
import MainHomeCM from "components/mainhome";
import ContactCM from "components/contactus";
import { HomePageRequest, getAccessorySliderRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import SkeletonNavCM from "components/shared/Skeleton/nav";
import Toast from "helper/toast";
import {Helmet} from "react-helmet";

export default function MainHome() {
  const { request, loading } = useHttp();
  const [image, setImage] = useState({ data: [], count: 0 });
  const [data, setData] = useState({
    categories: { accessory: [], furniture: [] },
    products: {
      accessory: { amazingOffer: [], fromEachCategory: [] },
      furniture: { amazingOffer: [], fromEachCategory: [] },
    },
    aboutus: { text: "" },
  });

  const getData = useCallback(async () => {
    let res = await request({
      url: HomePageRequest,
      values: {},
    });

    // if (res) {
    //   return Toast({
    //     type: "err",
    //     title: "عملیات",
    //   });
    // }

    setData({
      // categories: {
      //   accessory: res.categories["اکسسوری"],
      //   furniture: res.categories["مبلمان"],
      // },
      products: {
        accessory: {
          amazingOffer: res.products["اکسسوری"].amazing_offer,
          fromEachCategory: res.products["اکسسوری"].from_each_category,
        },
        furniture: {
          amazingOffer: res.products["مبلمان"].amazing_offer,
          fromEachCategory: res.products["مبلمان"].from_each_category,
        },
      },
      aboutus: res.about_us,
    });
  }, [request]);

  const getDataSlider = useCallback(async () => {
    const res = await request({
      url: getAccessorySliderRequest,
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      image: items.image,
    }));

    setImage({ data: transformedData });
  }, [request]);

  useEffect(() => {
    getData();
    getDataSlider();
  }, [getData, getDataSlider]);

  return (
    <Fragment>
      {/* {loading ? (
        <LoadingCM />
      ) : ( */}
      <Helmet>
        <title>صفحه اصلی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <>
        {/* {loading ? <SkeletonNavCM /> : <MenuCM IndexMenu Background />} */}
        <MenuCM IndexMenu Background />
        <MainSliderCM />
        <MainHomeCM
          AccessoryProducts={data?.products?.accessory.fromEachCategory}
          amazingAccessoryProducts={data?.products?.accessory.amazingOffer}
          furnitureProducts={data?.products?.furniture.fromEachCategory}
          amazingFurnitureProducts={data?.products?.furniture.amazingOffer}
          aboutUs={data?.aboutus?.text}
          slider={image?.data}
          Loading={loading ? true : false}
        />
        <ContactCM All />
        <FooterCM />
      </>
      {/* )} */}
    </Fragment>
  );
}
